import script from "./popoverSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./popoverSelect.vue?vue&type=script&setup=true&lang=ts"

import "./popoverSelect.vue?vue&type=style&index=0&id=02358080&lang=less"

const __exports__ = script;

export default __exports__